import { FC } from 'react'
import classNames from 'classnames'
import { Email } from 'constants/regex'
import { useTranslation } from 'next-i18next'
import { EmailFormFieldProps as Props } from '../types'
import { checkIsStaging } from 'utils/helpers'

const EmailFormFields: FC<Props> = ({
  emailLabel,
  formState,
  hasRepeat,
  hookFormSelector,
  isAlreadyCustomer,
  isUnknownCustomer,
  onChange,
  optional,
  readOnly,
  register,
  repeatEmailLabel,
  watch
}) => {
  // i18n
  const { t } = useTranslation(['commonFormFields', 'validation', 'common'])

  // Constants
  const { errors } = formState
  const watchEmail: string = watch('email')
  const emailKey: string = hookFormSelector?.email ?? 'email'
  const repeatKey: string = hookFormSelector?.repeatEmail ?? 'repeatEmail'
  const fieldProps = register(emailKey, {
    pattern: Email,
    required: !optional
  })

  return (
    <>
      {/* EMAIL */}
      <div className="form-input">
        <label htmlFor={emailKey}>{emailLabel ?? t('email.label')}</label>
        <input
          id={emailKey}
          type="email"
          className={classNames({ 'has-error': emailKey in errors || isAlreadyCustomer || isUnknownCustomer })}
          {...fieldProps}
          onChange={async (e) => {
            onChange?.()
            await fieldProps.onChange(e)
          }}
          readOnly={readOnly}
        />
        {errors && errors[emailKey] && (
          <p className="is-error-text">
            {errors[emailKey].type === 'required' && t('validation:required')}
            {errors[emailKey].type === 'pattern' && t('validation:email')}
          </p>
        )}
        {isAlreadyCustomer && <p className="mt-200 mb-400 is-red">{t('common:errors.alreadyCustomer')}</p>}
        {isUnknownCustomer && <p className="is-error-text">{t('emailNotKnown', 'We konden geen klant vinden met dit e-mailadres.')}</p>}
      </div>

      {/* REPEAT EMAIL */}
      {hasRepeat && (
        <div className="form-input">
          <label htmlFor={repeatKey} className="mb-100">
            {repeatEmailLabel ?? t('email.repeat')}
          </label>
          <input
            id={repeatKey}
            type="email"
            className={classNames({ 'has-error': repeatKey in errors })}
            {...register(repeatKey, {
              pattern: Email,
              required: true,
              validate: (value: string) => value.trim().toLowerCase() === watchEmail.trim().toLowerCase()
            })}
            onPaste={(e) => (checkIsStaging() ? undefined : e.preventDefault())}
            readOnly={readOnly}
          />
          {errors && errors[repeatKey] && (
            <p className="is-error-text">
              {errors[repeatKey].type === 'required' && t('validation:required')}
              {errors[repeatKey].type === 'pattern' && t('validation:email')}
              {errors[repeatKey].type === 'validate' && t('email.errors.notEqual')}
            </p>
          )}
        </div>
      )}
    </>
  )
}

export default EmailFormFields
